import parse from 'html-react-parser';
import { ClientParser } from '@/app_lib/htmlParser/client';
import { applyRulesToReactTree } from '@/app_lib/htmlParser/inserter/inserter';
import { insertionRules } from '@/app_lib/htmlParser/inserter/rules/helpers';
import type { ClientParserData, ParserRule } from '@/app_lib/htmlParser/inserter/rules/types';
import { options } from '@/app_lib/htmlParser/parsers/parserOptions';
import { AnalyticsEvent, ContentPlacement } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';

type Props = {
  content: string;
  rules?: ParserRule[]; // Optional additional rules for parsing
  clientData?: ClientParserData[];
};

const ServerParser = ({ content, rules = [] }: Props) => {
  const parsedContent = parse(content, options);
  const insertedContent = applyRulesToReactTree({
    elements: parsedContent,
    rules: [...insertionRules, ...rules],
  });
  return (
    <article
      className={cn('article-content', AnalyticsEvent.ImpressionElement)}
      data-cy={ContentPlacement.ArticleContent}
    >
      {insertedContent}
    </article>
  );
};

export const DescriptionParser = ({ content }: Props) => {
  return <span className='description-parser contents'>{parse(content)}</span>;
};

export const ContentParser = ({ content, rules, clientData }: Props) => {
  const oldParser = process.env.NEXT_PUBLIC_USE_OLD_HTML_PARSER === 'true';

  try {
    return oldParser ? (
      <ClientParser
        clientData={clientData}
        content={content}
        key='client-parser'
      />
    ) : (
      <ServerParser
        content={content}
        key='server-parser'
        rules={rules}
      />
    );
  } catch (error) {
    // biome-ignore lint/suspicious/noConsole: need error
    console.error('Error parsing HTML content:', error);
    return (
      <ClientParser
        clientData={clientData}
        content={content}
        key='fallback-client-parser'
      />
    );
  }
};
